module.exports = __webpack_public_path__ + "img/foot_dx.94aa598e.png";